import {
  getPaymentMethods,
  getPriceChart,
  getStatusCodes,
} from '../../api/ApiManager';
import {
  getPaymentMethodsSuccess,
  getPriceLevelsSuccess,
  getStatusCodesSuccess,
} from '../../routes/EventDetails/modules/eventDetails';
import {
  savePaymentMethods,
  savePriceLevelsToOffer,
  saveStatusCodes,
} from '../../routes/EventDetails/routes/EditOffer/modules/EditOfferModule';

export const stringToFunctionMapping = {
  PriceLevels: {
    fetch: (contextId, eventId, zoneId) =>
      getPriceChart(contextId, eventId, zoneId),
    success: (priceLevels) => getPriceLevelsSuccess(priceLevels),
    save: (priceLevels) => savePriceLevelsToOffer(priceLevels),
  },
  StatusCodes: {
    fetch: (contextId, eventId, zoneId) =>
      getStatusCodes(contextId, eventId, zoneId),
    success: (statusCodes) => getStatusCodesSuccess(statusCodes),
    save: (statusCodes) => saveStatusCodes(statusCodes),
  },
  PaymentMethods: {
    fetch: (contextId) => getPaymentMethods(contextId),
    success: (paymentMethods) => getPaymentMethodsSuccess(paymentMethods),
    save: (paymentMethods) => savePaymentMethods(paymentMethods),
  },
};



// WEBPACK FOOTER //
// ./src/common/sagas/constants.js